import { useI18n } from '@runtime/core/i18n/i18n'
import { useCoach } from './CoachContext'
import { useCoachLauncherPlacement } from './CoachLauncherPlacement'
import styles from './CoachResetPosition.module.scss'

export default function CoachResetPosition() {
  const { t } = useI18n()
  const { setOpen } = useCoach()
  const placement = useCoachLauncherPlacement()
  if (!placement) return null

  return (
    <button
      type="button"
      className={styles.resetPosition}
      onClick={() => {
        placement.resetPosition()
        setOpen(false)
      }}
      data-testid="coach-reset-position"
    >
      {t(
        placement.inGameActions
          ? 'strategy.actions.resetPosition'
          : placement.compact
            ? 'coach.resetCompactPosition'
            : 'coach.resetPosition',
      )}
    </button>
  )
}
